import { render } from "./RecursoEstrella.vue?vue&type=template&id=76c4fe82&scoped=true"
import script from "./RecursoEstrella.vue?vue&type=script&lang=js"
export * from "./RecursoEstrella.vue?vue&type=script&lang=js"

import "./RecursoEstrella.vue?vue&type=style&index=0&id=76c4fe82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76c4fe82"]])

export default __exports__